export default {
  id: 'location.sevenDayPerformance',
  name: 'location.sevenDayPerformance',
  displayName: '7 Day Performance Comparison',
  valueType: 'string',
  objectType: 'location',
  blueprint: {},
  get: obj => obj?.data?.analytics?.performance?.weekly
};